import { z } from 'zod'
import { responseSchema } from '@/core/types/Response.ts'
import { productTypeSchema } from '@/modules/sales/clients/types/articleTypes/Common.ts'

export const NuovoDeviceSchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  imei_no: z.string(),
  imei_no2: z.string().nullable(),
  serial_no: z.string(),
  phone_number: z.string().nullable(),
  model: z.string(),
  is_tv: z.boolean(),
  make: z.string(),
  os_version: z.string(),
  sdk_version: z.string(),
  status: z.string(),
  device_group_id: z.number().nullable(),
  lock_type: z.string(),
  admin_lock_type: z.string(),
  app_version_code: z.number(),
  app_version_name: z.string(),
  device_firmware: z.string(),
  created_at: z.string(),
  is_activated: z.boolean(),
  locked: z.boolean(),
  admin_locked: z.boolean(),
  is_locked_on_sim_swap: z.boolean(),
  first_lock_date: z.string().nullable(),
  first_lock_date_in_iso_format: z.string().nullable(),
  next_lock_date: z.string().nullable(),
  next_lock_date_in_iso_format: z.string().nullable(),
  customer_name: z.string().nullable(),
  customer_email: z.string().nullable(),
  customer_address: z.string().nullable(),
  customer_phone_number: z.string().nullable(),
  unlock_code: z.string().nullable(),
  validity_of_unlock_code: z.number().nullable(),
  custom_fields: z.array(z.any()),
  eula_status: z.string(),
  eula_action_performed_on: z.string(),
  sim_lock_info: z.object({
    approved: z.array(z.any()),
    unapproved: z.array(z.any()),
    auto_approve_new_sim: z.object({ state: z.any(), expiry_time: z.any() })
  }),
  device_setting_attributes: z.object({
    lock_on_sim_swap: z.string(),
    disable_unknown_sources: z.any(),
    mandatory_packages: z.any(),
    auto_lock_schedule: z.object({ scheduler_id: z.any(), name: z.any() })
  }),
  nuovoclub_details: z.object({
    nuovoclub_enabled: z.boolean(),
    is_password_set: z.boolean(),
    nuovoclub_language: z.any(),
    nuovoclub_users: z.array(z.any())
  }),
  last_connected_at: z.string(),
  getting_started_button_clicked: z.boolean(),
  enrollment_status: z.string(),
  enrollment_failure_reason: z.string().nullable(),
  additional_setup_done: z.union([z.boolean(), z.literal('NA')]),
  battery_optimization_granted: z.string(),
  enrolled_on: z.string(),
  supports_sms_lock_feature: z.boolean(),
  dlc_details: z.object({ dlc_status: z.string() }),
  renewal_status: z.string(),
  reset_password_details: z.object({
    password_set_on_device: z.boolean(),
    support_reset_password: z.boolean(),
    pasword_reset_status: z.string(),
    password_reset_code: z.string()
  }),
  device_type: z.object({ id: z.number(), name: z.string() })
})

export type NuovoDevice = z.infer<typeof NuovoDeviceSchema>

export const NuovoDeviceResponseSchema = responseSchema(NuovoDeviceSchema)

export type NuovoDeviceResponse = z.infer<typeof NuovoDeviceResponseSchema>

export const ModelDeviceSchema = z.object({
  brandId: z.string(),
  brandName: z.string(),
  id: z.string(),
  maxCost: z.string(),
  name: z.string()
})

export const ModelDeviceResponseSchema = responseSchema(ModelDeviceSchema)

export type ModelDeviceResponse = z.infer<typeof ModelDeviceResponseSchema>

export const CreditDetailsSchema = z.object({
  brandId: z.string(),
  brandName: z.string(),
  modelId: z.string(),
  modelName: z.string(),
  registerNumber: z.string(),
  branchOfficeName: z.string(),
  cost: z.string(),
  maxCost: z.string(),
  rentabilityId: z.string(),
  imei: z.string().optional(),
  additionalCost: z.string(),
  initial: z.string(),
  discountedCredit: z.string(),
  initialTotal: z.string(),
  totalPayment: z.string(),
  createByName: z.string(),
  extraPayment: z.string().nullable(),
  paymentByQuotes: z.string(),
  rate: z.string(),
  promotionDiscountPercentage: z.string(),
  isPromotionCreditLimit: z.boolean(),
  debtWhenAssigned: z.string(),
  creditBeforeAssign: z.string(),
  productTypeId: productTypeSchema
})

export const CreditAppleSchema = z.object({
  id: z.number(),
  imei: z.string(),
  brandId: z.number(),
  brandName: z.string(),
  modelId: z.number(),
  modelName: z.string()
})

export const CreditAppleResponseSchema = responseSchema(CreditAppleSchema)

export type CreditAppleResponse = z.infer<typeof CreditAppleResponseSchema>

export const CreditDetailsResponseSchema = responseSchema(CreditDetailsSchema)

export type CreditDetailsResponse = z.infer<typeof CreditDetailsResponseSchema>
